// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <>

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="150" height="60" viewBox="0 0 2206.000000 932.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,932.000000) scale(0.290000,-0.280000)"
fill="#1316c9" stroke="none">
<path d="M1500 3240 c-421 -31 -822 -231 -1098 -549 -532 -615 -528 -1532 8
-2140 243 -275 552 -450 922 -522 170 -34 426 -32 599 4 268 56 480 153 684
312 756 592 835 1711 171 2403 -335 349 -799 527 -1286 492z m-594 -448 c41
-21 70 -48 100 -97 18 -28 19 -67 24 -800 5 -760 5 -771 26 -816 85 -184 306
-235 452 -104 78 70 94 118 102 305 6 173 13 193 78 252 51 46 99 61 177 56
106 -7 182 -75 206 -188 17 -79 5 -304 -21 -405 -80 -311 -353 -539 -671 -561
-321 -22 -599 139 -740 430 -75 155 -74 137 -74 996 0 834 -2 809 58 876 71
81 189 104 283 56z m1126 3 c93 -24 216 -88 294 -154 116 -98 192 -213 242
-370 l27 -86 0 -790 0 -790 -22 -41 c-99 -185 -347 -174 -428 19 -13 31 -15
134 -15 769 0 834 2 810 -77 898 -62 69 -119 95 -213 94 -57 0 -85 -5 -116
-22 -61 -31 -101 -68 -131 -120 -26 -43 -28 -56 -33 -207 -5 -139 -9 -167 -29
-208 -40 -83 -114 -128 -207 -128 -66 0 -88 6 -141 42 -28 19 -50 47 -68 84
-27 54 -27 55 -23 242 4 179 6 192 35 276 17 48 46 113 64 144 46 78 190 222
266 266 75 43 188 85 263 97 75 12 235 4 312 -15z m-594 -1201 c56 -33 98 -92
113 -159 10 -46 9 -61 -6 -106 -23 -73 -48 -105 -108 -139 -119 -68 -271 -19
-328 105 -57 125 21 293 152 325 52 13 129 2 177 -26z"/>
<path d="M4170 750 l0 -480 40 0 40 0 0 480 0 480 -40 0 -40 0 0 -480z"/>
<path d="M3328 853 c-3 -254 -9 -279 -69 -303 -27 -12 -39 -11 -76 2 l-43 16
0 -64 c0 -60 2 -65 26 -74 71 -27 181 -3 236 52 60 60 68 105 68 370 l0 228
-69 0 -70 0 -3 -227z"/>
<path d="M3620 755 l0 -325 70 0 69 0 3 111 3 111 66 3 c86 4 139 21 185 58
93 77 101 233 15 310 -50 45 -106 57 -276 57 l-135 0 0 -325z m269 201 c49
-26 66 -99 35 -145 -21 -30 -72 -51 -124 -51 l-40 0 0 105 0 105 50 0 c28 0
63 -6 79 -14z"/>
<path d="M5400 740 l0 -320 35 0 35 0 0 320 0 320 -35 0 -35 0 0 -320z"/>
<path d="M4490 1003 c-67 -35 -93 -78 -87 -144 6 -69 34 -99 147 -159 108 -57
150 -96 150 -139 0 -99 -140 -120 -293 -43 -5 2 -7 -16 -5 -39 3 -40 6 -45 38
-56 52 -17 193 -16 237 2 51 22 70 40 89 91 35 93 -8 160 -149 230 -109 55
-137 81 -137 127 0 47 25 74 82 89 46 12 88 7 166 -17 20 -7 22 -4 22 29 0 46
-22 56 -129 56 -65 0 -86 -4 -131 -27z"/>
<path d="M6609 1018 c-42 -14 -70 -89 -37 -96 12 -2 21 5 28 22 12 32 37 33
90 6 53 -27 86 -25 115 6 31 33 34 74 6 74 -11 0 -22 -9 -26 -19 -9 -28 -33
-33 -69 -15 -49 25 -79 32 -107 22z"/>
<path d="M4974 835 c-78 -39 -114 -107 -114 -215 0 -72 35 -145 87 -180 29
-20 51 -26 112 -28 98 -4 152 21 196 93 27 43 30 57 30 129 0 64 -5 90 -22
123 -52 96 -182 132 -289 78z m174 -55 c42 -26 65 -79 64 -151 0 -104 -51
-162 -139 -162 -47 0 -82 20 -117 66 -27 36 -28 147 -3 195 37 68 128 92 195
52z"/>
<path d="M6210 844 c-46 -20 -87 -60 -112 -109 -30 -57 -30 -165 0 -222 24
-46 72 -88 115 -98 25 -7 27 -10 21 -40 -6 -32 -4 -34 27 -37 42 -4 62 -34 35
-54 -11 -8 -32 -14 -48 -14 -21 0 -28 -5 -28 -20 0 -17 7 -20 40 -20 53 0 86
17 101 52 10 25 9 33 -8 56 -11 15 -32 28 -47 30 -35 4 -32 36 4 40 14 2 40 8
58 13 28 9 32 15 32 45 l0 35 -32 -17 c-44 -23 -108 -22 -149 2 -45 26 -69 76
-69 143 0 127 104 203 215 157 l35 -15 0 35 c0 28 -5 36 -26 44 -38 15 -124
11 -164 -6z"/>
<path d="M6594 836 c-90 -42 -133 -141 -112 -258 19 -109 92 -168 206 -168 75
0 116 16 158 61 75 81 76 247 1 328 -57 62 -165 78 -253 37z m183 -67 c75 -70
71 -224 -9 -282 -34 -25 -101 -27 -146 -3 -101 52 -92 261 13 307 36 16 113 4
142 -22z"/>
<path d="M7105 841 c-53 -24 -91 -70 -110 -133 -18 -61 -18 -81 -4 -148 12
-56 53 -111 100 -136 38 -19 148 -18 199 2 36 14 40 20 40 50 0 33 -1 34 -22
20 -102 -65 -231 -21 -245 83 l-6 41 153 0 153 0 -5 63 c-7 81 -28 120 -81
152 -53 30 -114 33 -172 6z m145 -68 c16 -16 33 -43 36 -60 l7 -33 -117 0
c-64 0 -116 2 -116 5 0 25 35 78 62 95 47 28 91 26 128 -7z"/>
<path d="M7535 848 c-76 -27 -112 -100 -81 -165 13 -28 31 -41 101 -74 91 -42
116 -70 95 -109 -21 -39 -115 -45 -177 -12 -31 17 -33 16 -33 -23 0 -29 5 -37
26 -45 34 -13 143 -13 183 1 l31 11 0 98 0 98 -66 28 c-80 34 -94 46 -94 84 0
44 37 64 105 57 55 -6 55 -6 55 23 0 16 -7 30 -16 34 -24 9 -95 6 -129 -6z"/>
<path d="M5602 683 c4 -177 11 -205 58 -248 16 -14 40 -20 89 -23 65 -4 70 -3
104 28 l37 32 0 -26 c0 -24 4 -26 40 -26 l40 0 0 215 0 215 -40 0 -40 0 0
-155 0 -155 -33 -37 c-28 -30 -40 -36 -76 -36 -87 0 -109 53 -110 266 l-1 117
-36 0 -36 0 4 -167z"/>
</g>
</svg>
    </>
  );
}
